import React, { Component } from 'react';
import { Form, Modal } from 'antd';
import UploadFile from '@comm/upload/UploadFile';
import YearPicker from '@comm/YearPicker';

const FormItem = Form.Item;
class FormImportWage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleOk = () => {
    const {
      handleSubmit,
      form: { validateFields },
    } = this.props;
    validateFields((err, values) => {
      if (!err) {
        const params = {
          year: values.year,
          fileUuid: values.files[0].uuid,
        };
        handleSubmit(params);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { bonusLoading } = this.props;
    return (
      <Modal
        title="年终奖导入"
        onOk={this.handleOk}
        onCancel={this.props.handleCancel}
        confirmLoading={bonusLoading}
        visible
      >
        <Form>
          <FormItem label="发放年度">
            {getFieldDecorator('year', {
              rules: [{ required: true, message: '请选择发放年月' }],
            })(<YearPicker />)}
          </FormItem>
          <FormItem label="年终奖附件">
            {getFieldDecorator('files', {
              rules: [{ required: true, message: '请上传年终奖附件' }],
            })(<UploadFile limit={1} type="ghost" isPreview />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(FormImportWage);



// WEBPACK FOOTER //
// ./src/components/hr/wageImport/ModalImportBonus.js